var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25048 6.015V5C8.25048 4.00544 8.64556 3.05161 9.34882 2.34835C10.0521 1.64509 11.0059 1.25 12.0005 1.25C12.995 1.25 13.9489 1.64509 14.6521 2.34835C15.3554 3.05161 15.7505 4.00544 15.7505 5V6.015C17.0375 6.054 17.8255 6.192 18.4265 6.691C19.2595 7.383 19.4795 8.553 19.9185 10.894L20.6685 14.894C21.2855 18.186 21.5935 19.832 20.6945 20.916C19.7945 22 18.1195 22 14.7705 22H9.23047C5.88048 22 4.20648 22 3.30648 20.916C2.40648 19.832 2.71648 18.186 3.33248 14.894L4.08248 10.894C4.52248 8.554 4.74148 7.383 5.57448 6.691C6.17548 6.192 6.96348 6.054 8.25048 6.015ZM9.75048 5C9.75048 4.40326 9.98753 3.83097 10.4095 3.40901C10.8314 2.98705 11.4037 2.75 12.0005 2.75C12.5972 2.75 13.1695 2.98705 13.5915 3.40901C14.0134 3.83097 14.2505 4.40326 14.2505 5V6H9.75048V5Z",
    fill: "#FFA439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.5e541b1ba3e78dec4daaea596aa283d2.svg";
export { ForwardRef as ReactComponent };